// Drop keys whose values are undefined, null, or empty string so analytics payloads only
// carry meaningful properties before schema validation. Mirrors mb3-frontend's omitEmpty.
export function omitEmpty<T extends Record<string, unknown>>(
  obj: T,
): Partial<T> {
  const result: Partial<T> = {}

  for (const key of Object.keys(obj) as Array<keyof T>) {
    const value = obj[key]
    if (value === undefined || value === null || value === '') {
      continue
    }

    result[key] = value
  }

  return result
}
